"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendientesResumenSchema = exports.AuditoriaListResponseSchema = exports.RegistroAuditoriaResponseSchema = exports.RevertAlertaSchema = exports.UpdateAlertaEstadoSchema = exports.AlertasListResponseSchema = exports.AlertaResponseSchema = exports.AdminUsuarioInfoSchema = void 0;
const zod_1 = require("zod");
// ───────────── Usuario info (shared, admin-facing) ─────────────
exports.AdminUsuarioInfoSchema = zod_1.z.object({
    idUsuario: zod_1.z.number().int().positive(),
    correo: zod_1.z.string(),
    nombre: zod_1.z.string().nullable(),
});
// ───────────── Alertas del sistema (alerta_sistema) ─────────────
exports.AlertaResponseSchema = zod_1.z.object({
    idAlerta: zod_1.z.number().int().positive(),
    categoria: zod_1.z.string(),
    tipoAlerta: zod_1.z.string(),
    severidad: zod_1.z.string(),
    estado: zod_1.z.string(),
    titulo: zod_1.z.string(),
    mensaje: zod_1.z.string().nullable(),
    idInvestigador: zod_1.z.number().nullable(),
    tipoObjeto: zod_1.z.string().nullable(),
    idObjeto: zod_1.z.string().nullable(),
    origenTipo: zod_1.z.string(),
    origenReferencia: zod_1.z.string().nullable(),
    detallesJson: zod_1.z.unknown().nullable(),
    createdAt: zod_1.z.string(),
    handledAt: zod_1.z.string().nullable(),
    handledByUserId: zod_1.z.number().nullable(),
    handledComment: zod_1.z.string().nullable(),
    // true si es una alerta de estamento (rol_basico) con datos suficientes para que
    // un admin la rechace y revierta el cambio (restaurar estamento previo + borrar cargo).
    revertible: zod_1.z.boolean().optional().default(false),
});
exports.AlertasListResponseSchema = zod_1.z.object({
    alertas: zod_1.z.array(exports.AlertaResponseSchema),
});
exports.UpdateAlertaEstadoSchema = zod_1.z.object({
    estado: zod_1.z.enum(['en_revision', 'resuelta', 'descartada']),
    handledComment: zod_1.z.string().max(2000).optional().nullable(),
});
// Rechazo/reversión de una alerta de estamento (rol_basico). El comentario es opcional.
// `estamentoSlugDestino` deja que el admin ELIJA a qué estamento queda la persona (el viaje
// pudo pasar por varios). Si se omite (undefined), se usa el estamento previo guardado; si es
// null, la persona queda sin estamento.
exports.RevertAlertaSchema = zod_1.z.object({
    handledComment: zod_1.z.string().max(2000).optional().nullable(),
    estamentoSlugDestino: zod_1.z.string().max(64).nullable().optional(),
});
// ───────────── Registro de auditoría (registro_auditoria) ─────────────
exports.RegistroAuditoriaResponseSchema = zod_1.z.object({
    idRegistro: zod_1.z.number().int().positive(),
    idUsuario: zod_1.z.number().int().positive(),
    accion: zod_1.z.string(),
    objetoTipo: zod_1.z.string(),
    objetoId: zod_1.z.number().nullable(),
    objetoIdentificador: zod_1.z.string().nullable(),
    descripcion: zod_1.z.string().nullable(),
    valoresAnteriores: zod_1.z.string().nullable(),
    valoresNuevos: zod_1.z.string().nullable(),
    metadataJson: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    usuario: exports.AdminUsuarioInfoSchema.nullable(),
});
exports.AuditoriaListResponseSchema = zod_1.z.object({
    registros: zod_1.z.array(exports.RegistroAuditoriaResponseSchema),
    total: zod_1.z.number().int().nonnegative(),
});
// ───────────── Resumen de pendientes admin (R50) ─────────────
//
// Per-category count of "things to review" so the admin sees them at a glance:
// a badge on each admin module card plus the summed total on the sidebar.
//
// "Pending" mirrors the semantics already used elsewhere in the app:
//   - solicitudes: estado IN ('nueva', 'en_revision')  (see SolicitudesService.listPendientes)
//   - alertas:     estado IN ('pendiente', 'en_revision')  (see the alert-detail `isOpen`)
//   - correos:     credencial del emisor en problema + envíos fallidos recientes (R60)
//
// `correos` se deriva del ESTADO, no de una fila que alguien tenga que resolver a
// mano: al reconectar la cuenta el contador se apaga solo. Una alerta_sistema
// habría quedado "pendiente" después de arreglado, que es justo la deuda falsa
// que el proyecto evita.
//
// Extensible: add a new category as another non-negative field here + include it
// in `total`; the generic badge and sidebar sum need no changes.
exports.PendientesResumenSchema = zod_1.z.object({
    solicitudes: zod_1.z.number().int().nonnegative(),
    alertas: zod_1.z.number().int().nonnegative(),
    correos: zod_1.z.number().int().nonnegative(),
    // R67: ítems del purgatorio de publicaciones por revisar (decisiones, conflictos, ambiguas).
    publicaciones: zod_1.z.number().int().nonnegative(),
    total: zod_1.z.number().int().nonnegative(),
});
